import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import classNames from "classnames";
import HeaderLinks from "components/Header/HeaderLinks.js";
import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import SectionCarousel from "./Sections/SectionCarousel";
import DashboardWithoutLogin from "components/ManualOrder/DashboardWithoutLogin";
import { useDispatch, useSelector } from "react-redux";
import DashboardLoggedIn from "components/ManualOrder/DashboardLogged/DashboardLoggedIn";
import axios from "axios";
import { getInternal } from "redux/ducks/manageInternal";
import { setInternal } from "redux/ducks/manageInternal";
import { setCommonLoginToken } from "../../lib/useLocalStorageUser";
import CustomerListDialog from "views/CSPDashboardPage/Sections/Component/CustomerListDialog";
import { useLocation } from "react-router-dom";
import { post } from "lib/requests";
import { ErrorMessage, LoadingMessage } from "components/Common/toastify";
import { SuccessMessage } from "components/Common/toastify";
import { setUser } from "redux/ducks/userSlice";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import SectionFooter from "./Sections/SectionFooter";
import SectionContactUs from "./Sections/SectionContactUs";

const useStyles = makeStyles(sectionsPageStyle);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function SectionsPage() {
	const classes = useStyles();
	const params = new URLSearchParams(window.location.search);
	const dispatch = useDispatch();
	const location = useLocation();
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const queryParams = new URLSearchParams(location.search);
	const [dialogToggle, setDialogToggle] = useState(false);
	const userLoginToken = queryParams.get("userlogintoken");
	const router = {
		query: {
			token: params.get("token"),
			email: params.get("email"),
			name: params.get("name"),
		},
	};
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const ourRequest = axios.CancelToken.source();
	const userDetails = useSelector((state) => state.user);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		if (userDetails?.token) {
			// redirectLogin(userDetails);
		}
		if (userLoginToken) {
			checkUrlLogin();
		} else {
			checkSalesPersonLogin();
		}

		return function cleanup() {};
	}, []);

	const redirectLogin = (response) => {
		if (response.callnext == "resetpassword") {
			window.location.href = "/reset-password";
			return;
		} else if (response.callnext == "login/qrcode") {
			window.location.href = "/login-qr-code";
			return;
		} else if (response.callnext == "resetpassword") {
			window.location.href = "/login-mfa";
			return;
		} else if (
			response.callnext == "login/mfa" ||
			response.callnext == "login/pin"
		) {
			window.location.href = "/login-mfa";
			return;
		} else {
			if (userDetails?.csp || response.csp) {
				window.location.href = "/csp-dashboard";
			} else {
				window.location.href = "/dashboard";
			}
			return;
		}
	};

	// get token from URL
	const checkUrlLogin = async () => {
		await loginWithToken();
	};

	const loginWithToken = async () => {
		setIsLoading(true);
		setError(null);
		LoadingMessage("User with token login", "Please wait...");
		try {
			await post(`/api/user/loginwithtoken`, {
				userlogintoken: userLoginToken,
			})
				.then((res) => {
					if (res.data.success) {
						const response = res.data.records;
						SuccessMessage("User with token login", "Login success");
						dispatch(setUser(response));
						redirectLogin(response);
					} else {
						ErrorMessage("Login", res.data.message);
					}
					setIsLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("User with token login", message);
					setIsLoading(false);
				});
		} catch (error) {
			console.log("error", error);
			ErrorMessage("User with token login", "Something went wrong try again!!");
			setIsLoading(false);
		}
	};

	// get token from URL
	const checkSalesPersonLogin = async () => {
		if (router.query?.token) {
			await verifyLogin();
			dispatch(getInternal());
		}
	};

	const verifyLogin = async () => {
		setIsLoading(true);
		setError(null);
		await axios
			.post(
				`https://apps.auscomp.au/api/checklogin`,
				{},
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + router.query.token,
					},
				}
			)
			.then((res) => {
				if (res.data.success) {
					setCommonLoginToken({
						...res.data,
						token: router.query.token,
					});
					// setLoginToken(router.query.token);
					setIsLoading(false);
					setDialogToggle(true);
					setError(null);
					let flag = false;
					if (
						router.query.email == "Jaydip.Bhingradiya@auscompcomputers.com" ||
						router.query.email == "rinku.kamboj@auscompcomputers.com"
					) {
						flag = true;
						router.query.email = "adrian.cross@auscompcomputers.com";
					}

					const internalData = {
						name: router.query.name,
						email: flag ? "adrian.cross@auscompcomputers.com" : router.query.email,
						token: router.query.token,
						user: res.data.user,
						userRoles: res.data.userRoles,
						corporateuser: res.data.corporateuser,
					};
					dispatch(setInternal(internalData));
				} else {
					setIsLoading(false);
					setError("There is no forms available.");
				}
			})
			.catch((err) => {
				setIsLoading(false);
				setError("Error in special forms fetching...");
			});
	};

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>

			<div className={classNames(classes.main, classes.mainBackground)}>
				<div className={classNames(isLoading ? classesCSStyles.loading : "")}>
					<SectionCarousel />

					{!userDetails?.token ? <DashboardLoggedIn /> : <DashboardWithoutLogin />}
					<div className={classNames(classes.chooseSection, classesCSStyles.my10)}>
						<div className={classes.container}>
							<div className={classes.landingTitle}>
								<h2> Why Choose Auscomp for SaaS Distribution?</h2>
							</div>
							<div
								className={classNames(
									classes.landingDescription,
									classesCSStyles.my10
								)}>
								At Auscomp Cloud, we bridge the gap between world-class SaaS vendors and
								local Australian IT providers. Whether you’re an MSP, VAR, or IT
								department, we help you scale with reliable cloud tools backed by
								responsive Australian support.
							</div>
							<GridContainer
								className={classNames(classesCSStyles.my10, classesCSStyles.py5)}>
								<GridItem md={6} sm={2}>
									<img
										className={classes.landingImage}
										src="/assets/images/landing/why-choose-us.png"
										alt="why-choose-us"
									/>
								</GridItem>
								<GridItem md={6} sm={2}>
									<div className={classes.keyDescription}>
										<div className={classes.keyTitle}>Key Advantages</div>
										<ul className={classes.keyPoints}>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												Tier-1 Microsoft CSP with instant license provisioning
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												API-driven portal for automation & scalability
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												White-label SaaS opportunities for resellers
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>{" "}
												Cybersecurity-first focus with compliance-ready products
											</li>
											<li>
												{" "}
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												Dedicated pre-sales and post-sales support
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>{" "}
												Local warehousing + Australian-based support
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												Boost productivity and collaboration with Microsoft 365—your
												all-in-one SaaS solution for modern business.
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												Streamline communication with Access4—SaaS voice and UC tools for
												fast, seamless IT service delivery.
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>
												Protect your business with TeamT5—SaaS-based advanced threat
												detection backed by expert cybersecurity insights.
											</li>
											<li>
												<span>
													<i className="fas fa-space-shuttle" />
												</span>{" "}
												Safeguard your data with Vembu—SaaS backup and disaster recovery for
												physical, virtual, and cloud systems.
											</li>
										</ul>
									</div>
								</GridItem>
							</GridContainer>
						</div>
					</div>
					<div
						className={classNames(classes.chooseProductPortfolio)}
						id="product-portfolio">
						<div className={classes.container}>
							<div className={classes.landingTitle}>
								<h2>Our SaaS Product Portfolio</h2>
							</div>
							<div
								className={classNames(
									classes.landingDescription,
									classesCSStyles.my10
								)}>
								At Auscomp Computers, we bring together a curated portfolio of SaaS
								solutions from some of the world’s most innovative and trusted
								technology vendors. Our platform is designed to empower IT resellers and
								service providers with access to industry-leading tools across cloud
								productivity, cybersecurity, backup, VoIP, and more.
							</div>
							<div
								className={classNames(
									classes.landingDescription,
									classesCSStyles.my10
								)}>
								<strong>
									Explore our product portfolio and manage your subscriptions with ease
									through our self-service portal.
								</strong>{" "}
								Gain instant access to quoting, provisioning, and support — all in one
								place.
							</div>
							<GridContainer
								className={classNames(classesCSStyles.my10, classesCSStyles.py5)}>
								<GridItem md={6} sm={6}>
									<div className={classes.keyDescription}>
										<ul className={classes.keyPointsSecurity}>
											<li className={classes.keyPointSection}>
												<div className={classes.keyTitle}>
													<span>
														<i className="fas fa-snowflake" />
													</span>
													Cybersecurity
												</div>
												<div>
													We offer a range of email filtering, endpoint protection & zero
													trust platforms:
												</div>
												<ul className={classes.keyPointSubSection}>
													<li>
														<span>
															<i className="fas fas fa-bolt" />
														</span>
														ThreatVision (Threat Intelligence Platform)
													</li>

													<li>
														<span>
															<i className="fas fas fa-bolt" />
														</span>
														SentinelOne (Autonomous endpoint, cloud, and identity protection)
													</li>

													<li>
														<span>
															<i className="fas fas fa-bolt" />
														</span>
														Proofpoint (Adaptive AI across the entire email delivery chain)
													</li>

													<li>
														<span>
															<i className="fas fas fa-bolt" />
														</span>
														Mimecast (Comprehensive cloud-based email security)
													</li>

													<li>
														<span>
															<i className="fas fas fa-bolt" />
														</span>
														Safeweb (Proactive detection of dark web threats)
													</li>
												</ul>
											</li>
											<li className={classes.keyPointSection}>
												<div className={classes.keyTitle}>
													<span>
														<i className="fas fa-snowflake" />
													</span>
													Voice & Communications
												</div>
												<ul className={classes.keyPointSubSection}>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														3CX VoIP PBX
													</li>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														CloudTalk Contact Centre
													</li>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Access4 Unified Communications
													</li>
												</ul>
											</li>
											<li className={classes.keyPointSection}>
												<div className={classes.keyTitle}>
													<span>
														<i className="fas fa-snowflake" />
													</span>
													Backup & Business Continuity
												</div>
												<ul className={classes.keyPointSubSection}>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Cloud-to-cloud backup
													</li>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Disaster recovery as a service (DRaaS)
													</li>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Email & SharePoint archival
													</li>
												</ul>
											</li>
											<li className={classes.keyPointSection}>
												<div className={classes.keyTitle}>
													<span>
														<i className="fas fa-snowflake" />
													</span>{" "}
													Productivity & Licensing
												</div>
												<ul className={classes.keyPointSubSection}>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Microsoft 365, Azure, Teams Phone
													</li>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Software licensing and asset management
													</li>
													<li>
														<span>
															<i className="fas fa-bolt" />
														</span>
														Remote desktop solutions
													</li>
												</ul>
											</li>
										</ul>
									</div>
								</GridItem>
								<GridItem md={6} sm={6} className={classes.portFolioImage}>
									<img
										className={classes.landingImage}
										src="/assets/images/landing/private-network-website-security.png"
										alt="Cyber Security"
									/>
								</GridItem>
							</GridContainer>
						</div>
					</div>
					<div className={classNames(classes.chooseSection, classesCSStyles.my10)}>
						<div className={classes.container}>
							<div className={classes.landingTitle}>
								<h2>Unified SaaS Management and Distribution for Resellers</h2>
							</div>
							<div
								className={classNames(
									classes.landingDescription,
									classesCSStyles.my10
								)}>
								Deliver, manage, and automate cloud services with ease. Designed to help
								MSPs and resellers scale securely and efficiently.Manage cloud licenses,
								automate provisioning, and streamline operations— all from a secure,
								unified portal built for modern IT providers.
							</div>
							<GridContainer className={classes?.mainKeyPoint}>
								<GridItem md={5} sm={5} className={classes?.keyMainSection}>
									<div className={classes.keyDescription}>
										<div className={classes.keyTitle}>
											<span>
												<i className="fas fa-bullseye" />
											</span>
											Reseller Focused Distribution
										</div>
										<div>
											Our SaaS distribution model is designed with resellers and system
											integrators in mind. Whether you’re looking to expand your product
											stack or automate license delivery, we support your success through:
										</div>
										<ul className={classes.keyPoints}>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Unified Reseller Portal
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Flexible Billing Models (monthly, annual, per-user)
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Partner API Access
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Sales Enablement Tools
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												White-Label Marketing Collateral
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Training & Certification Programs
											</li>
										</ul>
									</div>
								</GridItem>
								<GridItem md={5} sm={5} className={classes?.keyMainSection}>
									<div className={classes.keyDescription}>
										<div className={classes.keyTitle}>
											<span>
												<i className="fas fa-bullseye" />
											</span>{" "}
											Powered by the Auscomp SaaS Portal
										</div>
										<div>
											Manage all your cloud licenses, services, billing, and provisioning
											in one place.
										</div>
										<ul className={classes.keyPoints}>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												User-friendly dashboard
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Instant M365 license provisioning
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Billing & usage visibility
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Subscription lifecycle management
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Integration-ready API for automation
											</li>
										</ul>
									</div>
								</GridItem>
								<GridItem md={5} sm={5} className={classes?.keyMainSection}>
									<div className={classes.keyDescription}>
										<div className={classes.keyTitle}>
											<span>
												<i className="fas fa-bullseye" />
											</span>{" "}
											Built for Security and Compliance
										</div>
										<div>
											Security is at the core of every offering we provide. Our cloud
											services meet key compliance frameworks and are hosted through
											globally trusted vendors with local support:
										</div>
										<ul className={classes.keyPoints}>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Secure Identity & Access Management
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Data sovereignty options for AU clients
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Zero-trust cybersecurity integration
											</li>
										</ul>
									</div>
								</GridItem>
								<GridItem md={5} sm={5} className={classes?.keyMainSection}>
									<div className={classes.keyDescription}>
										<div className={classes.keyTitle}>
											{" "}
											<span>
												<i className="fas fa-bullseye" />
											</span>
											Who We Serve
										</div>
										<div>We partner with a wide range of organizations:</div>
										<ul className={classes.keyPoints}>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Managed Service Providers (MSPs)
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												Value-Added Resellers (VARs)
											</li>
											<li>
												<span>
													<i className="fas fa-hand-point-up" />
												</span>
												SMBs, Enterprises & Government Departments
											</li>
										</ul>
									</div>
								</GridItem>
							</GridContainer>
						</div>
					</div>
					<div
						id="about-us"
						className={classNames(
							classes.chooseProductPortfolio,
							classesCSStyles.my10
						)}>
						<div className={classes.container}>
							<GridContainer
								className={classNames(classesCSStyles.my10, classesCSStyles.py5)}>
								<GridItem md={6} sm={2}>
									<img
										className={classes.landingImage}
										src="/assets/images/landing/about-us.jpg"
										alt="why-choose-us"
									/>
								</GridItem>
								<GridItem md={6} sm={2}>
									<div className={classes.keyDescription}>
										<div className={classes.keyTitle}>ABOUT US</div>
										<div className={classes.landingTitle2}>
											<h2> Trusted. Responsive. 100% Australian Cloud Distributor.</h2>
										</div>
										<ul className={classes.aboutUsKeyPoints}>
											<li>Australian-Owned & Operated.</li>
											<li>Fast Provisioning & Automation.</li>
											<li>Dedicated Account Management</li>
											<li>Advanced SaaS Distribution Platform</li>
											<li> Sales and technical support.</li>
											<li>Vendor Partnerships.</li>
											<li>Driven by Innovation.</li>
										</ul>
										<div
											className={classNames(
												classes.landingDescription,
												classesCSStyles.my10
											)}>
											Auscomp Computers Pty Ltd. is a 100% Australian-owned IT distributor
											based in Brisbane. With over 25 years of experience, we’ve built
											strong relationships with global IT brands and thousands of resellers
											across Australia.
										</div>
										<div
											className={classNames(
												classes.landingDescription,
												classesCSStyles.my10
											)}>
											Whether you’re looking to streamline communication, enhance security,
											or ensure business continuity, our diverse range of SaaS offerings
											has you covered.
										</div>
										<div
											className={classNames(
												classes.landingDescription,
												classesCSStyles.my10
											)}>
											Our cloud division is the next chapter in that journey — empowering
											Australian businesses with the digital tools they need to grow
											securely, efficiently, and profitably.
										</div>

										<div>
											<br />
											<br />
											<a
												href="https://auscompcomputers.com/customer"
												className={classes.joinUs}>
												Join Us Today
												<span>
													<i className="fas fa-chevron-right" />
												</span>
											</a>
										</div>
									</div>
								</GridItem>
							</GridContainer>
						</div>
					</div>
					<SectionContactUs />
					<SectionFooter />
				</div>
			</div>
			{dialogToggle && (
				<CustomerListDialog
					loginToken={router.query.token ? router.query.token : userDetails?.token}
					dialogToggle={dialogToggle}
					setDialogToggle={setDialogToggle}
				/>
			)}
		</div>
	);
}
